import { apiClientConfig, callApi } from "@/utils/api-utils"
import { MedicalApi } from "@vitable/asclepius-api-client-ts"

const state = () => ({
  overdueMedicalChartsCount: 0
})

const getters = {
  overdueMedicalChartsCount: (state) => {
    return state.overdueMedicalChartsCount
  }
}

const actions = {
  async getOverdueMedicalChartsCount({ commit, rootGetters }) {
    const medicalApi = new MedicalApi(apiClientConfig())
    const requestParams = {
      overdueIn: true
    }
    if (rootGetters["me/isProvider"]) requestParams.providerId = rootGetters["me/providerId"]

    try {
      const response = await callApi(() => medicalApi.listDynamicMedicalCharts(requestParams), this)

      commit("setOverdueMedicalChartsCount", {
        count: response.count
      })
    } catch (e) {
      console.error(e)
      return e
    }
  }
}

const mutations = {
  setOverdueMedicalChartsCount(state, { count }) {
    state.overdueMedicalChartsCount = count
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
